export function cleanDate (date) {
  const newDate = date.slice(0, 10);
  // console.log("cleanDate", newDate);
  return newDate;
};

